module.exports = __webpack_public_path__ + "img/PartheasLogo.b7f48b78.png";